import { render } from "./BattlesFilterSort.vue?vue&type=template&id=14be990e&scoped=true"
import script from "./BattlesFilterSort.vue?vue&type=script&lang=js"
export * from "./BattlesFilterSort.vue?vue&type=script&lang=js"

import "./BattlesFilterSort.vue?vue&type=style&index=0&id=14be990e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14be990e"]])

export default __exports__